import TrainingManagement from "../../modules/training-management/views/TrainingManagement.vue"
import TrainingManagementForm from "../../modules/training-management/components/forms/TrainingManagementForm.vue"

import RouterViewRender from "../../utils/routes/router-view-render";

const TrainingManagementRoutes = {
  path: "",
  component: RouterViewRender,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "gestao-treinamentos",
      component: TrainingManagement,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "formulario-gestao-treinamento/:id",
      component: TrainingManagementForm,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "formulario-gestao-treinamento",
      component: TrainingManagementForm,
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default TrainingManagementRoutes;
